import * as React from "react";

function PhotoStrip({ photos, reverse = false }) {
  return (
    <div
      className={`trps-photo-strip${reverse ? " trps-photo-strip--reverse" : ""}`}
      aria-label="TRAPSの活動風景"
    >
      {photos.map((photo) => (
        <figure className="trps-photo-strip__item" key={photo.alt}>
          {photo.video ? (
            <video
              src={photo.video}
              aria-label={photo.alt}
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
              disablePictureInPicture
            />
          ) : (
            <img src={photo.image} alt={photo.alt} loading="lazy" />
          )}
        </figure>
      ))}
    </div>
  );
}

export default PhotoStrip;
